export default "__VITE_ASSET__DxA57fVL__"